import { formatValue } from '@/utils';
import dayjs from 'dayjs';
import { formatEmpty } from '../../ZtOutCall/utils';
export const getHandleData = (t, total)=>[
        /** 所有消息数 */ {
            key: 1,
            label: t('c_a_ai_all_messages'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.total_message_num),
            tooltip: t('c_a_ai_all_messages_tips')
        },
        /** 客户消息数 */ {
            key: 2,
            label: t('c_a_ai_customer_messages'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.customer_message_num)
        },
        /** AI总回复消息数 */ {
            key: 3,
            label: t('c_a_ai_Total_ai_reply_messages'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.jekka_reply_message_num),
            tooltip: t('c_a_ai_Total_ai_reply_messages_tips')
        },
        /** 人工总回复消息数 */ {
            key: 4,
            label: t('c_a_ai_Total_manually_replied'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.operator_reply_message_num),
            tooltip: t('c_a_ai_Total_manually_replied_tips')
        },
        /** 日均回复数/条-试用前 */ {
            key: 5,
            label: t('c_a_ai_daily_average_before'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.before_daily_reply_num),
            tooltip: t('c_a_ai_daily_average_before_tips')
        },
        /** 日均回复数/条-试用后 */ {
            key: 6,
            label: t('c_a_ai_daily_average_after'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.after_daily_reply_num),
            tooltip: t('c_a_ai_daily_average_after_tips')
        },
        /** 日均回复数/条 */ {
            key: 7,
            label: t('c_a_ai_replies_article'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.after_daily_reply_num, '%'),
            tooltip: t('c_a_ai_replies_article_tips')
        },
        /** AI回复占比 */ {
            key: 8,
            label: t('c_a_ai_proportion_of_ai_replies'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.jekka_reply_message_rate, '%'),
            tooltip: t('c_a_ai_proportion_of_ai_replies_tips')
        },
        /** 回复数降低 */ {
            key: 9,
            label: t('c_a_ai_decreased_replies'),
            value: formatValue(total === null || total === void 0 ? void 0 : total.daily_reply_reduce_rate, '%'),
            tooltip: t('c_a_ai_decreased_replies_tips')
        }
    ];
/** 按照AI试用报告配置展示权限 */ export const getVisibleKeys = (repliesNum)=>!repliesNum ? [
        1,
        2,
        3,
        4,
        7,
        8
    ] : [
        1,
        2,
        3,
        5,
        6,
        7,
        9
    ];
export const getLabelMap = (t)=>({
        /** 日均咨询客户数 */ daily_customer_num: t('c_a_ai_daily_average_clients'),
        /** 日均客户消息数 */ customer_message_num: t('c_a_ai_daily_average_messages'),
        /** 日均人工回复消息数 */ daily_operator_reply_num: t('c_a_ai_daily_average_manually_replied')
    });
/** ECharts配置 */ export const getOptions = (t, mergeData)=>{
    /** 提取xAxis的日期和series数据 */ const dates = mergeData.map((item)=>dayjs(item.create_date).format('MM/DD'));
    /** 客户消息数 */ const customerMessages = mergeData.map((item)=>item.customer_message_num ?? 0);
    /** 人工回复消息数 */ const manualReplies = mergeData.map((item)=>item.operator_reply_message_num ?? 0);
    /** 人工回复占比 */ const replyRate = mergeData.map((item)=>{
        const rate = parseFloat(item.operator_reply_message_rate ?? '0');
        return isNaN(rate) ? 0 : rate;
    });
    return {
        title: {
            text: t('c_a_ai_customer_vs_manually'),
            left: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 16
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            textStyle: {
                fontFamily: 'inherit' /** 继承全局图表字体 */ ,
                fontSize: 12,
                color: '#333'
            },
            formatter: (params)=>{
                if (!(params === null || params === void 0 ? void 0 : params.length)) return '';
                const index = params[0].dataIndex;
                const item = mergeData[index];
                const customer = item.customer_message_num ?? 0;
                const manual = item.operator_reply_message_num ?? 0;
                const rate = item.operator_reply_message_rate ?? 0;
                const seriesInfo = [
                    {
                        name: t('c_a_ai_customer_messages'),
                        value: customer.toLocaleString(),
                        color: '#ffb72b',
                        unit: ''
                    },
                    {
                        name: t('c_a_ai_jekka_backend'),
                        value: manual.toLocaleString(),
                        color: '#8EE085',
                        unit: ''
                    },
                    {
                        name: t('c_a_ai_proportion_manual_replies'),
                        value: rate,
                        color: '#8B5CF6',
                        unit: '%'
                    }
                ];
                let tooltipStr = `<div style="line-height:22px; font-family:inherit;">`;
                tooltipStr += `<div style="font-weight:bold;margin-bottom:6px;">${item.create_date}</div>`;
                seriesInfo.forEach((s)=>{
                    tooltipStr += `
            <div style="margin-bottom:4px;">
              <span style="display:inline-block;width:8px;height:8px;background:${s.color};border-radius:50%;margin-right:6px;"></span>
              ${s.name}: ${s.value}${s.unit}
            </div>
          `;
                });
                tooltipStr += '</div>';
                return tooltipStr;
            },
            backgroundColor: '#fff',
            borderColor: '#ccc',
            borderWidth: 1,
            extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.15);'
        },
        legend: {
            /** 图例：客户消息数、人工在Jekka后台回复消息数、人工回复占比 */ data: [
                t('c_a_ai_customer_messages'),
                t('c_a_ai_jekka_backend'),
                t('c_a_ai_proportion_manual_replies')
            ],
            bottom: 0
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '12%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: dates
        },
        yAxis: [
            {
                type: 'value',
                position: 'left',
                min: 0
            },
            {
                type: 'value',
                position: 'right',
                min: 0,
                max: 'dataMax',
                axisLabel: {
                    formatter: '{value}%'
                },
                scale: true,
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#eee',
                        type: 'dashed'
                    }
                }
            }
        ],
        series: [
            {
                name: t('c_a_ai_customer_messages'),
                type: 'bar',
                data: customerMessages,
                barWidth: (customerMessages === null || customerMessages === void 0 ? void 0 : customerMessages.length) < 15 ? 40 : 'auto',
                itemStyle: {
                    normal: {
                        color: '#ffb72b',
                        barBorderRadius: [
                            6,
                            6,
                            0,
                            0
                        ]
                    }
                },
                label: {
                    show: true,
                    position: 'top',
                    align: 'center',
                    formatter: (params)=>{
                        const value = params.value;
                        return formatEmpty(value);
                    }
                }
            },
            {
                name: t('c_a_ai_jekka_backend'),
                type: 'bar',
                data: manualReplies,
                barWidth: (manualReplies === null || manualReplies === void 0 ? void 0 : manualReplies.length) < 15 ? 40 : 'auto',
                itemStyle: {
                    normal: {
                        color: '#8EE085',
                        barBorderRadius: [
                            6,
                            6,
                            0,
                            0
                        ]
                    }
                },
                label: {
                    show: true,
                    position: 'top',
                    align: 'center',
                    formatter: (params)=>{
                        const value = params.value;
                        return formatEmpty(value);
                    }
                }
            },
            {
                name: t('c_a_ai_proportion_manual_replies'),
                type: 'line',
                yAxisIndex: 1,
                data: replyRate,
                itemStyle: {
                    color: '#8B5CF6'
                },
                lineStyle: {
                    width: 2
                },
                label: {
                    show: true,
                    position: 'top',
                    align: 'center',
                    verticalAlign: 'bottom',
                    formatter: (params)=>{
                        const value = params.value;
                        if (value === null || value === undefined || isNaN(value)) return '';
                        return value.toFixed(2) + '%';
                    }
                },
                smooth: true
            }
        ]
    };
};
